import { WEB_URL } from "@/config/endpoints";
import { convertToIST } from "@/lib/istTime";

export const generateAuthorPageSchema = (authorDetails,recentPosts,locale) => {
    if (!recentPosts) return {};

    const featuredImage = recentPosts._embedded?.['wp:featuredmedia']?.[0]?.source_url || '';
    const publishedDate = convertToIST(recentPosts.date);
    const pageUrl = `${WEB_URL}${locale === 'es-mx' ? '/es-mx/blogs/' : '/blogs/'}${recentPosts.slug}`;
    const linkedInUrl = authorDetails.yoast_head_json.schema["@graph"][3].sameAs.find(url => url.includes('linkedin.com'));
    const authorProfileImage = authorDetails.yoast_head_json.schema["@graph"][3].sameAs[1] || '';
    const authorPageUrl = `${WEB_URL}${locale === 'es-mx' ? '/es-mx/author/' : '/author/'}${authorDetails.slug}`;
    const authorDesignation = (authorDetails.yoast_head_json.schema["@graph"][3].sameAs[2] || "").replace(/\s*,\s*Credlix/i, "")
    const websiteName =  WEB_URL + `${locale === 'es-mx' ? '/es-mx' : ''}`;

    return { 
      "@context": "https://schema.org",
      "@type": "ProfilePage",
      "dateCreated": "2026-02-28T12:34:00-05:00",
      "dateModified": "2026-02-28T14:53:00-05:00",
      "url": authorPageUrl,
      "publisher": {
        "@type": "Organization",
        "name": "Credlix",
        "url": websiteName,
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.credlix.com/_next/static/media/credlix-logo.c7d919cd.png",
          "width": 170,
          "height": 48
        },
        "sameAs": [
          "https://www.facebook.com/credlix/",
          "https://twitter.com/_credlix",
          "https://www.linkedin.com/company/credlix/"
        ]
      },
      'mainEntity': {
        "@type": "Person",
        "@id": authorPageUrl,
        "name": authorDetails.name,
        "identifier": authorDetails.id,
        "description": authorDetails.description,
        "image": authorProfileImage,
        "sameAs": [
          linkedInUrl
        ],
        "url": authorPageUrl,
        "image": {
          "@type": "ImageObject",
          "url": authorProfileImage,
        },
        "jobTitle": authorDesignation,
        "sameAs": [
          linkedInUrl
        ],
        "worksFor": {
          "@type": "Organization",
          "name": "Credlix"
        }
       },
      "hasPart": [{
        "@type": "Article",
        "headline": recentPosts.title.rendered,
        "url": pageUrl,
        "datePublished": publishedDate,
        "image": featuredImage,
        "author": {
          "@id": authorPageUrl}
      }]
    };
  }
